module.exports = "<span class=\"c-status-tag__container\" [style.background-color]=\"backColor\" [style.color]=\"fontColor\">{{label}}</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/status-tag/status-tag.component.html
// module id = ./src/app/modules/common-module/components/status-tag/status-tag.component.html
// module chunks = 9